@if (hasGlobalError()) {
  <tap-global-error></tap-global-error>
} @else {
  @if (consentRequired()) {
    <div class="consent-blocking-placeholder"></div>
  } @else {
    <router-outlet></router-outlet>
  }
}
